<template>
  <div>
    <PageAllow controller="Announcements" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color" v-show="!currentItemMode">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- +发布公告 -->
              <v-btn
                small
                color="primary"
                class="ms-1"
                @click.stop="currentItemMode = 'new'"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("Announcement.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 公告标题 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    v-model="options.title"
                    @text="KeyWord = $event"
                    :label="$t('Announcement.title')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherAccountUser
                    v-model="accountUserSelected"
                    createrName
                    :type="[1, 2]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    settings &&
                    settings.miniprogram &&
                    settings.miniprogram.template_id == '3'
                  "
                >
                  <v-select
                    v-model="options.type"
                    :items="$consts.announcementTypes"
                    item-value="value"
                    item-text="text"
                    :label="$t('Announcement.types.title')"
                    clearable
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    v-model="options.user_types"
                    :items="announcementUserTypes"
                    item-value="value"
                    item-text="text"
                    :label="$t('Announcement.user_type.title')"
                    clearable
                    multiple
                    chips
                    small-chips
                    deletable-chips
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('Announcement.status.title')"
                    :items="$consts.announcementStatus"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="announcements"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.created="{ item, index }">
            <span :v-resize="!index ? $stickTableResizer() : null"> </span>
            {{ item.created | formatTime }}
          </template>
          <template v-slot:item.type="{ item }">
            {{
              item.type == 1
                ? $t("Announcement.types.type_one")
                : item.type == 2
                ? $t("Announcement.types.type_two")
                : ""
            }}
          </template>
          <template v-slot:item.user_type="{ item }">
            {{
              item.user_type == 1
                ? $t("Announcement.user_type.user_type_shop", [
                    $consts.shopName(),
                  ])
                : item.user_type == 2
                ? $t("Announcement.user_type.user_type_supplier")
                : item.user_type == 3
                ? $t("Announcement.user_type.user_type_agent", [
                    $consts.allianceName(),
                  ])
                : ""
            }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('Announcements', 'view')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentItemMode = 'view';
                    currentItem = item;
                  "
                >
                  <!-- :href="'/#/announcement/' + item.id" -->
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("Announcement.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("Announcement.detail") }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  :href="'/#/announcement/push-to-shop/' + item.id"
                  v-if="item.user_type == 1"
                >
                  {{ $t("Announcement.shop", [$consts.shopName()]) }}
                </v-btn>
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  :href="'/#/announcement/push-to-supplier/' + item.id"
                  v-if="item.user_type == 2"
                >
                  {{ $t("Announcement.supplier") }}
                </v-btn>
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  :href="'/#/announcement/push-to-alliance/' + item.id"
                  v-if="item.user_type == 3"
                >
                  {{ $t("Announcement.agent", [$consts.allianceName()]) }}
                </v-btn>
              </template>
              <span>
                {{
                  item.user_type == 1
                    ? $t("Announcement.shop", [$consts.shopName()])
                    : item.user_type == 2
                    ? $t("Announcement.supplier")
                    : item.user_type == 3
                    ? $t("Announcement.agent", [$consts.allianceName()])
                    : ""
                }}</span
              >
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="showHide(item.id)"
                >
                  {{
                    item.state_flg == 0
                      ? $t("Announcement.display")
                      : $t("Announcement.hide")
                  }}
                </v-btn>
              </template>
              <span>{{
                item.state_flg == 0
                  ? $t("Announcement.display")
                  : $t("Announcement.hide")
              }}</span>
            </v-tooltip>

            <v-tooltip top v-if="item.state_flg">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    topDialog = true;
                    topId = item.id;
                    topFlg = item.top_flg;
                  "
                >
                  {{
                    item.top_flg == 1
                      ? $t("Announcement.cancelTop")
                      : $t("Announcement.top")
                  }}
                </v-btn>
              </template>
              <span>{{
                item.top_flg == 1
                  ? $t("Announcement.cancelTop")
                  : $t("Announcement.top")
              }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    delDialog = true;
                    delId = item.id;
                  "
                >
                  {{ $t("Announcement.delete") }}
                </v-btn>
              </template>
              <span>{{ $t("Announcement.delete") }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.state_flg | announcementColor"
              :text-color="item.state_flg | announcementTextColor"
            >
              {{ item.state_flg | announcementText }}
            </v-chip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <v-dialog v-model="topDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="topDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{
            this.topFlg == 1
              ? $t("Announcement.cancel_text")
              : $t("Announcement.text")
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="topDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="Top()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="delDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("Announcement.del_text") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="delDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="Del()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AnnouncementsDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getAnnouncementFromAPI()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Announcement from "@/api/announcement";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import AnnouncementsDetail from "./plugins/Detail";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  title: "",
  user_ids: [],
  status: [0, 1],
  type: null,
  user_types: [],
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("announcenments-options")
        ? sessionStorage.getItem("announcenments-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    announcements: [],
    accountUserSelected: null,
    topDialog: false,
    delDialog: false,
    topId: null,
    topFlg: null,
    addAccountUser: null,
    currentItem: null,
    currentItemMode: null,
  }),
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.customerMaintenance"),
        disabled: false,
        href: "/qacenter",
      },
      {
        text: i18n.t("Nav.announcement"),
        disabled: true,
        href: "/announcement",
      },
    ],

    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Announcement.date"),
      },
    ],

    headers() {
      var headers = [
        {
          text: i18n.t("Announcement.Fields.title"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "title",
        },
        {
          text: i18n.t("Announcement.Fields.creater_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "creater.name",
        },
      ];
      if (
        this.settings &&
        this.settings.miniprogram &&
        this.settings.miniprogram.template_id == "3"
      ) {
        headers.push({
          text: i18n.t("Announcement.types.title"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "type",
        });
      }
      headers.push(
        {
          text: i18n.t("Announcement.user_type.title"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "user_type",
        },
        {
          text: i18n.t("Announcement.Fields.shop_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop_count",
        },
        {
          text: i18n.t("Announcement.Fields.read_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "read_count",
        },
        {
          text: i18n.t("Announcement.Fields.no_read_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "no_read_count",
        },
        {
          text: i18n.t("Announcement.Fields.state_flg"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("Announcement.Fields.created"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },

    announcementUserTypes() {
      return [
        {
          text: i18n.t("Announcement.user_type.user_type_shop", [
            this.$consts.shopName(),
          ]),
          value: 1,
        },
        {
          text: i18n.t("Announcement.user_type.user_type_supplier"),
          value: 2,
        },
        {
          text: i18n.t("Announcement.user_type.user_type_agent", [
            this.$consts.allianceName(),
          ]),
          value: 3,
        },
      ];
    },

    ...mapState(["loading", "stickTableCols", "settings"]),
  },

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherAccountUser,
    SearcherStatus,
    AnnouncementsDetail,
  },

  mounted() {
    this.$commonUtils.loadOptions("announcenments", ["accountUserSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "accountUserSelected":
              this.accountUserSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        title: this.KeyWord,
      });
      // this.getAnnouncementFromAPI();
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.accountUserSelected = null;
    },

    getAnnouncementFromAPI() {
      if (
        this.settings &&
        this.settings.miniprogram &&
        this.settings.miniprogram.template_id != "3"
      ) {
        delete this.options.type;
      }
      Announcement.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.announcements = response.data.announcements;
            // console.log(this.announcements);
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },

    showHide(id) {
      Announcement.showHide(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getAnnouncementFromAPI();
          }
        }.bind(this)
      );
    },
    Top() {
      Announcement.top(this.topId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getAnnouncementFromAPI();
          }
          this.topDialog = false;
        }.bind(this)
      );
    },
    Del() {
      Announcement.del(this.delId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getAnnouncementFromAPI();
          }
          this.delDialog = false;
        }.bind(this)
      );
    },
  },

  watch: {
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },

    options: {
      deep: true,
      handler() {
        this.getAnnouncementFromAPI();
        sessionStorage.setItem(
          "announcenments-options",
          JSON.stringify(this.options)
        );
      },
    },
    accountUserSelected: {
      handler() {
        this.options.user_ids = this.accountUserSelected
          ? [this.accountUserSelected.id]
          : "";
        sessionStorage.setItem(
          "announcenments-accountUserSelected",
          JSON.stringify(this.accountUserSelected)
        );
      },
    },
    addAccountUser: {
      handler() {
        // console.log(this.addAccountUser);
      },
    },
    settings: {
      immediate: true,
      handler() {
        this.getAnnouncementFromAPI();
      },
    },
  },
};
</script>

<style>
</style>